import React, { Component } from "react";
import _ from 'i18n';
import {Col, Row} from "antd";

export default class CycleDataTable extends Component {

  render() {

    return (
    <div className={'event-datatable'} style={{borderTop : 'none', paddingTop : '0'}}>
      <Row className="event-stats-title ml-6 mr-6" justify="space-around">
        <Col offset={1} span={3}>{_('Date')}</Col>
        <Col span={7}>{_('TITLE')}</Col>
        <Col offset={1} span={3}>{_('PAID_REGISTRANTS')}</Col>
        <Col offset={1} span={3}>{_('FREE_REGISTRANTS')}</Col>
        <Col offset={1} span={4}>{_('TOTAL')}</Col>
      </Row>
      <br/>
    </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/CycleDataTable.js